var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTShirtAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19034 3L2.6946 4.49582C2.20868 4.65749 1.9194 5.15507 2.01985 5.65645L2.634 8.7218C2.7538 9.31977 3.3715 9.67761 3.95103 9.48477L5.90641 8.83411V19.9862C5.90641 20.5461 6.36111 21 6.92201 21H17.078C17.6389 21 18.0936 20.5461 18.0936 19.9862V8.83411L20.049 9.48477C20.6285 9.67761 21.2462 9.31977 21.366 8.7218L21.9801 5.65645C22.0806 5.15507 21.7913 4.65749 21.3054 4.49582L16.8097 3C16.6508 5.05045 15.1955 6.7927 13.17 7.29819C12.4018 7.48991 11.5982 7.48991 10.83 7.29819C8.80447 6.7927 7.34916 5.05045 7.19034 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.278 3.01349C13.1386 3.64447 10.8614 3.64447 8.72205 3.01349C8.88079 4.35894 9.85713 5.48785 11.1995 5.82285C11.7251 5.95402 12.2749 5.95402 12.8005 5.82285C14.1429 5.48785 15.1192 4.35894 15.278 3.01349Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTShirtAlt1);
export default __webpack_public_path__ + "static/media/t-shirt-alt-1.88878da819b8f018f243a1d1bcbe2782.svg";
export { ForwardRef as ReactComponent };